import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { installNumberInputGuards } from './utils/numberInputs';

// Stop scroll and arrow keys from silently changing amounts in number inputs
installNumberInputGuards();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);